import DebouncedTextField from "@/components/DebouncedTextField";
import Text from "@/components/Text";
import SectionAccordion from "./SectionAccordion";
import VitalsGrid from "./VitalsGrid";
import {
  FREE_TEXT_LABEL,
  FREE_TEXT_MAX_ROWS,
  FREE_TEXT_PLACEHOLDER,
} from "../readmission-f2f-constant";
import { ReadmissionSectionProps } from "../readmission-f2f-types";
import {
  buildFreeTextEntry,
  buildVitalsLines,
} from "../readmission-f2f-summary-utils";

const VitalSignsSection = ({
  title,
  expanded,
  onToggle,
  payload,
  update,
}: ReadmissionSectionProps) => {
  const summaryLines = [
    ...buildVitalsLines(payload.vitalSigns),
    ...buildFreeTextEntry(payload.vitalSignsFreeText),
  ];

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      summaryLines={summaryLines}
      showCurrentVisit={false}
      unmountWhenCollapsed
    >
      <VitalsGrid
        value={payload.vitalSigns}
        onChange={(vitalSigns) => update({ vitalSigns })}
      />
      <Text fontWeight="bold">{FREE_TEXT_LABEL}</Text>
      <DebouncedTextField
        size="small"
        fullWidth
        multiline
        minRows={3}
        maxRows={FREE_TEXT_MAX_ROWS}
        placeholder={FREE_TEXT_PLACEHOLDER}
        value={payload.vitalSignsFreeText}
        onChange={(vitalSignsFreeText) => update({ vitalSignsFreeText })}
      />
    </SectionAccordion>
  );
};

export default VitalSignsSection;
